export default __webpack_public_path__ + "static/media/preview-mobile-icon.63df0efe.svg";